export function setupEvents(svg, wrapper, data, panZoom) {
  function onPointerEnter(event) {
    const nodeId = event.target.getAttribute("data-node-id")
    if (!nodeId) return

    const node = data.nodesById[nodeId]
    if (!node) return

    const rackIndex = parseInt(event.target.getAttribute("data-rack-index"), 10)
    const clusterId = event.target.getAttribute("data-cluster-id")

    const detail = {
      clusterId: clusterId,
      rackIndex: rackIndex,
      node: {
        id: node.id,
        name: node.name,
        metadata: node.metadata,
        index: node.index,
        uNumber: node.uNumber,
        status: node.status,
        datasets: {},
      },
    }

    wrapper.dispatchEvent(new CustomEvent("nodehover", { detail: detail }))
  }

  function onPointerLeave(event) {
    const nodeId = event.target.getAttribute("data-node-id")
    if (!nodeId) return

    const node = data.nodesById[nodeId]
    if (!node) return

    const rackIndex = parseInt(event.target.getAttribute("data-rack-index"), 10)
    const clusterId = event.target.getAttribute("data-cluster-id")

    const detail = {
      clusterId: clusterId,
      rackIndex: rackIndex,
      node: {
        id: node.id,
        name: node.name,
        metadata: node.metadata,
        index: node.index,
        uNumber: node.uNumber,
        status: node.status,
        datasets: {},
      },
    }

    wrapper.dispatchEvent(new CustomEvent("nodeunhover", { detail: detail }))
  }

  function onClick(event) {
    if (panZoom && panZoom.suppressClick) {
      panZoom.suppressClick = false
      return
    }

    const nodeId = event.target.getAttribute("data-node-id")
    if (!nodeId) return

    const node = data.nodesById[nodeId]
    if (!node) return

    const rackIndex = parseInt(event.target.getAttribute("data-rack-index"), 10)
    const clusterId = event.target.getAttribute("data-cluster-id")

    let svgPoint = svg.createSVGPoint()
    svgPoint.x = event.clientX
    svgPoint.y = event.clientY
    const ctm = svg.getScreenCTM()
    if (ctm) {
      svgPoint = svgPoint.matrixTransform(ctm.inverse())
    }

    const detail = {
      node: {
        clusterId: clusterId,
        rackIndex: rackIndex,
        node: {
          id: node.id,
          name: node.name,
          metadata: node.metadata,
          index: node.index,
          uNumber: node.uNumber,
          status: node.status,
          datasets: {},
        },
        position: { x: svgPoint.x, y: svgPoint.y },
      },
      rack: null,
      rackU: null,
    }

    wrapper.dispatchEvent(new CustomEvent("vdcclick", { detail: detail }))
  }

  svg.addEventListener("pointerenter", onPointerEnter, true)
  svg.addEventListener("pointerleave", onPointerLeave, true)
  svg.addEventListener("click", onClick)
  window.addEventListener("resize", panZoom.onResize)

  return function cleanup() {
    svg.removeEventListener("pointerenter", onPointerEnter, true)
    svg.removeEventListener("pointerleave", onPointerLeave, true)
    svg.removeEventListener("click", onClick)
    window.removeEventListener("resize", panZoom.onResize)
  }
}
